import {CognitoUserPool} from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: "sa-east-1_vKFExtmyr",
    ClientId: "6hvur95pcicfoe1n4e7fkqtdrp"
}

export default new CognitoUserPool(poolData);